import { formatDate } from '@/utils/datetime';
// ナレッジのページテンプレート。
// PILOT E (Communication Reviewer, Jun 2026): 議事録 had no template, so minutes
// were written free-form without owners or due dates. This enforces the standard
// layout from COMMUNICATION_STYLE_GUIDE.md §4.
const today = () => formatDate(new Date());

const th = (t, w) => `<th${w ? ` colwidth="${w}"` : ''}><p>${t}</p></th>`;
const td = (t = '') => `<td><p>${t}</p></td>`;

const MINUTES_HTML = () => `
<h2>会議概要</h2>
<table><tbody>
<tr>${th('日時', 140)}${td(`${today()} 00:00〜00:00`)}</tr>
<tr>${th('場所', 140)}${td('会議室 / オンライン')}</tr>
<tr>${th('目的', 140)}${td('この会議で決めること（1行）')}</tr>
<tr>${th('記録者', 140)}${td('')}</tr>
</tbody></table>

<h2>参加者</h2>
<p><strong>出席</strong>：</p>
<p><strong>欠席</strong>：</p>

<h2>議題</h2>
<ol><li><p></p></li><li><p></p></li></ol>

<h2>決定事項</h2>
<ul><li><p>（決まったことを事実として1行で記載）</p></li></ul>

<h2>アクション項目</h2>
<table><tbody>
<tr>${th('対応事項', 320)}${th('担当', 120)}${th('期限', 110)}${th('状態', 90)}</tr>
<tr>${td()}${td()}${td()}${td('未着手')}</tr>
<tr>${td()}${td()}${td()}${td('未着手')}</tr>
</tbody></table>
<p><em>担当と期限は必須です。決められない場合は「いつ決めるか」を期限に入れてください。</em></p>

<h2>フォローアップ</h2>
<table><tbody>
<tr>${th('次回会議', 140)}${td('日時 / 目的')}</tr>
<tr>${th('保留事項', 140)}${td('')}</tr>
</tbody></table>
`.trim();

export const PAGE_TEMPLATES = [
  { key: 'blank', label: '空のページ', hint: '白紙から書き始めます', title: '', html: '' },
  {
    key: 'minutes',
    label: '議事録',
    hint: '会議概要・決定事項・アクション項目（担当／期限）',
    title: `議事録 ${today()}`,
    html: MINUTES_HTML,
  },
];

export function templateBody(tpl) {
  return {
    title: tpl.title || '',
    content_html: typeof tpl.html === 'function' ? tpl.html() : (tpl.html || ''),
  };
}
